export default __webpack_public_path__ + "static/media/jet.69a166d3.png";